/** Stored values for projects.payment_conditions */
export const PAYMENT_CONDITION_MILESTONE = "Milestone based";
export const PAYMENT_CONDITION_ONE_TIME = "One time";

export const PAYMENT_CONDITION_OPTIONS = [
  { value: PAYMENT_CONDITION_MILESTONE, label: "Milestone based" },
  { value: PAYMENT_CONDITION_ONE_TIME, label: "One time" },
];

export const DEFAULT_PAYMENT_CONDITION = PAYMENT_CONDITION_MILESTONE;

/** Map legacy / alias values to a current dropdown value. */
export function normalizePaymentCondition(value) {
  const raw = String(value ?? "").trim().toLowerCase();
  if (
    raw === "per milestone" ||
    raw === "milestone based" ||
    raw === "milestone_based" ||
    raw === "milestone-based"
  ) {
    return PAYMENT_CONDITION_MILESTONE;
  }
  if (raw === "one time" || raw === "one_time" || raw === "one-time") {
    return PAYMENT_CONDITION_ONE_TIME;
  }
  const match = PAYMENT_CONDITION_OPTIONS.find(
    (o) => o.value.toLowerCase() === raw,
  );
  return match?.value || DEFAULT_PAYMENT_CONDITION;
}

export function paymentConditionLabel(value) {
  return normalizePaymentCondition(value);
}

export function isOneTimePaymentCondition(value) {
  return normalizePaymentCondition(value) === PAYMENT_CONDITION_ONE_TIME;
}

export function isMilestoneBasedPaymentCondition(value) {
  return normalizePaymentCondition(value) === PAYMENT_CONDITION_MILESTONE;
}

/** Remove leading "#N " / "Milestone N:" from stored titles for display. */
export function stripMilestoneTitlePrefix(title) {
  return String(title || "")
    .replace(/^#\s*\d+\s+/i, "")
    .replace(/^milestone\s*\d+\s*:\s*/i, "")
    .trim();
}

/**
 * User-facing title for a deliverable row.
 * One-time orders never show "Milestone N" labels.
 */
export function displayDeliverableTitle(title, options = {}) {
  const {
    paymentCondition,
    projectName,
    sequence,
    fallback,
  } = options;
  const oneTime = isOneTimePaymentCondition(paymentCondition);
  const raw = String(title || "").trim();
  const project = projectName != null ? String(projectName).trim() : "";

  if (oneTime) {
    const stripped = stripMilestoneTitlePrefix(raw);
    if (stripped) return stripped;
    if (project) return project;
    return fallback || "Order";
  }

  if (raw) return raw;
  const seq = sequence != null ? Number(sequence) : NaN;
  if (Number.isFinite(seq) && seq > 0) {
    return project ? `Milestone ${seq}: ${project}` : `Milestone ${seq}`;
  }
  return fallback || "Milestone";
}

/** Freelancers may add milestones only before the business accepts the proposal. */
export function canFreelancerAddMilestoneToProposal(
  paymentCondition,
  proposalStatus,
) {
  if (isOneTimePaymentCondition(paymentCondition)) return false;
  const ps = String(proposalStatus || "").toLowerCase();
  return ps === "pending";
}
